var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGok1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 256,
    viewBox: "0 0 257 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6484 42.387L96.6484 64.1144L82.7365 72.1465L82.7365 50.419L96.6484 42.387Z",
    fill: "#6580E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6505 64.1144L77.8339 53.2507L63.922 61.2828L82.7385 72.1465L96.6505 64.1144Z",
    fill: "#6580E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8359 53.2506L77.8359 118.433L63.924 126.465L63.924 61.2827L77.8359 53.2506Z",
    fill: "#6580E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8339 118.433L96.6505 129.296L82.7385 137.329L63.922 126.465L77.8339 118.433Z",
    fill: "#6580E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6484 129.297L96.6484 151.024L82.7365 159.056L82.7365 137.329L96.6484 129.297Z",
    fill: "#6580E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6484 151.024L171.914 194.478L158.002 202.51L82.7365 159.056L96.6484 151.024Z",
    fill: "#6580E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.914 194.478L171.914 129.296L158.002 137.328L158.002 202.51L171.914 194.478Z",
    fill: "#6580E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.918 129.296L134.285 107.569L120.373 115.601L158.006 137.328L171.918 129.296Z",
    fill: "#6580E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.281 107.569L134.281 129.296L120.369 137.328L120.369 115.601L134.281 107.569Z",
    fill: "#6580E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.279 129.296L153.096 140.16L139.184 148.192L120.367 137.328L134.279 129.296Z",
    fill: "#6580E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.102 140.16L153.102 161.887L139.19 169.919L139.19 148.192L153.102 140.16Z",
    fill: "#6580E1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.099 161.887L96.6503 129.296L82.7384 137.329L139.187 169.919L153.099 161.887Z",
    fill: "#6580E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6484 129.296L96.6484 64.1143L82.7365 72.1463L82.7365 137.328L96.6484 129.296Z",
    fill: "#6580E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6505 64.1144L153.1 96.7053L139.188 104.737L82.7385 72.1465L96.6505 64.1144Z",
    fill: "#6580E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.102 96.7052L153.102 74.9778L139.19 83.0098L139.19 104.737L153.102 96.7052Z",
    fill: "#6580E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.1 74.9778L96.6505 42.3869L82.7385 50.4189L139.188 83.0098L153.1 74.9778Z",
    fill: "#6580E1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6505 42.3869L96.6504 64.1143L77.8339 53.2506L77.8339 118.433L96.6504 129.296L96.6504 151.024L171.916 194.478L171.916 129.296L134.283 107.569L134.283 129.296L153.1 140.16L153.1 161.887L96.6504 129.296L96.6504 64.1143L153.1 96.7052L153.1 74.9778L96.6505 42.3869Z",
    fill: "#D9D9D9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3946 44.4911L82.3946 69.6509L71.3848 76.0074L71.3848 50.8476L82.3946 44.4911Z",
    fill: "#6580E1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3992 69.6509L147.766 107.391L136.756 113.747L71.3894 76.0074L82.3992 69.6509Z",
    fill: "#6580E1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.766 107.391L147.766 157.711L136.756 164.067L136.756 113.747L147.766 107.391Z",
    fill: "#6580E1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.766 157.71L104.188 132.551L93.1784 138.907L136.756 164.067L147.766 157.71Z",
    fill: "#6580E1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.184 132.551L104.184 107.391L93.1739 113.748L93.1739 138.908L104.184 132.551Z",
    fill: "#6580E1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.18 107.391L82.3907 94.8114L71.3809 101.168L93.1699 113.748L104.18 107.391Z",
    fill: "#6580E1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3907 94.8114L82.3907 145.131L71.3809 151.487L71.3809 101.168L82.3907 94.8114Z",
    fill: "#6580E1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3992 145.131L169.555 195.45L158.545 201.807L71.3895 151.487L82.3992 145.131Z",
    fill: "#6580E1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.555 195.45L169.555 94.8104L158.545 101.167L158.545 201.807L169.555 195.45Z",
    fill: "#6580E1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.547 94.8105L82.3914 44.4913L71.3816 50.8478L158.537 101.167L169.547 94.8105Z",
    fill: "#6580E1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3913 44.4931L82.3913 69.6529L147.758 107.393L147.758 157.712L104.18 132.553L104.18 107.393L82.3913 94.8133L82.3913 145.133L169.547 195.452L169.547 94.8123L82.3913 44.4931Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.062 223.715V205.067L143.538 220.958V239.607L171.062 223.715Z",
    fill: "#6580E1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.061 205.067L187.211 214.391L159.687 230.282L143.537 220.958L171.061 205.067Z",
    fill: "#6580E1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.211 214.391V195.743L159.687 211.634V230.282L187.211 214.391Z",
    fill: "#061C43"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.209 195.743L203.359 205.067L175.835 220.958L159.685 211.634L187.209 195.743Z",
    fill: "#061C43"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.359 205.067V111.825L175.835 127.716V220.958L203.359 205.067Z",
    fill: "#061C43"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.359 111.825L187.209 102.501L159.685 118.392L175.835 127.716L203.359 111.825Z",
    fill: "#6580E1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.211 102.501V83.8525L159.687 99.7437V118.392L187.211 102.501Z",
    fill: "#6580E1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.211 83.8524L171.061 74.5282L143.537 90.4195L159.687 99.7437L187.211 83.8524Z",
    fill: "#6580E1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.062 74.5282V55.8798L143.538 71.771V90.4194L171.062 74.5282Z",
    fill: "#6580E1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.062 55.8798L90.3126 9.2588L62.7882 25.15L143.538 71.771L171.062 55.8798Z",
    fill: "#6580E1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3125 9.25885V27.9072L62.7881 43.7985V25.1501L90.3125 9.25885Z",
    fill: "#061C43"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3125 27.9072L74.1625 18.583L46.6381 34.4743L62.7881 43.7985L90.3125 27.9072Z",
    fill: "#6580E1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1562 18.5831V37.2315L46.6318 53.1227V34.4743L74.1562 18.5831Z",
    fill: "#061C43"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1562 37.2315L58.0063 27.9073L30.4819 43.7985L46.6318 53.1227L74.1562 37.2315Z",
    fill: "#6580E1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0078 27.9072V121.149L30.4834 137.04V43.7985L58.0078 27.9072Z",
    fill: "#6580E1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0063 121.149L74.1562 130.473L46.6318 146.365L30.4819 137.04L58.0063 121.149Z",
    fill: "#061C43"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1562 130.473V149.122L46.6318 165.013V146.365L74.1562 130.473Z",
    fill: "#6580E1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1625 149.122L90.3125 158.446L62.7881 174.337L46.6381 165.013L74.1625 149.122Z",
    fill: "#061C43"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3125 158.446V177.094L62.7881 192.986V174.337L90.3125 158.446Z",
    fill: "#6580E1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3126 177.094L171.062 223.715L143.538 239.607L62.7882 192.986L90.3126 177.094Z",
    fill: "#061C43"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.062 223.715L143.538 239.607L171.062 223.715Z",
    fill: "#6580E1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.059 223.715V205.067L187.209 214.391V195.743L203.359 205.067V111.825L187.209 102.501V83.8525L171.059 74.5283V55.8799L90.3095 9.25896V27.9073L74.1595 18.5831V37.2316L58.0096 27.9073V121.149L74.1595 130.474V149.122L90.3095 158.446V177.094L171.059 223.715Z",
    fill: "#16346C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6344_33285)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.059 223.715V205.067L187.209 214.391V195.743L203.359 205.067V111.825L187.209 102.501V83.8525L171.059 74.5283V55.8799L90.3095 9.25896V27.9073L74.1595 18.5831V37.2316L58.0096 27.9073V121.149L74.1595 130.474V149.122L90.3095 158.446V177.094L171.059 223.715Z",
    fill: "url(#paint0_linear_6344_33285)"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.562 34.356L110.563 56.0834L96.6506 64.1155L96.6506 42.388L110.562 34.356Z",
    fill: "#6580E1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.565 56.0834L91.748 45.2197L77.8361 53.2518L96.6526 64.1155L110.565 56.0834Z",
    fill: "#6580E1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.75 45.2196L91.75 110.402L77.8381 118.434L77.8381 53.2517L91.75 45.2196Z",
    fill: "#6580E1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.562 121.266L110.562 142.993L96.6506 151.025L96.6506 129.298L110.562 121.266Z",
    fill: "#6580E1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.562 142.993L185.828 186.447L171.916 194.479L96.6506 151.025L110.562 142.993Z",
    fill: "#061C43"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.828 186.447L185.828 121.265L171.916 129.297L171.916 194.479L185.828 186.447Z",
    fill: "#061C43"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.832 121.265L148.199 99.5376L134.287 107.57L171.92 129.297L185.832 121.265Z",
    fill: "#6580E1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.195 99.5377L148.195 121.265L134.283 129.297L134.283 107.57L148.195 99.5377Z",
    fill: "#6580E1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.193 121.265L167.01 132.129L153.098 140.161L134.281 129.297L148.193 121.265Z",
    fill: "#061C43"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.016 132.129L167.016 153.856L153.104 161.888L153.104 140.161L167.016 132.129Z",
    fill: "#6580E1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.013 153.856L110.564 121.265L96.6525 129.298L153.102 161.888L167.013 153.856Z",
    fill: "#6580E1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.562 121.265L110.562 56.0833L96.6506 64.1153L96.6506 129.297L110.562 121.265Z",
    fill: "#6580E1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.565 56.0834L167.014 88.6743L153.102 96.7064L96.6526 64.1155L110.565 56.0834Z",
    fill: "#061C43"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.016 88.6742L167.016 66.9468L153.104 74.9788L153.104 96.7063L167.016 88.6742Z",
    fill: "#061C43"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.014 66.9468L110.565 34.3559L96.6526 42.3879L153.102 74.9788L167.014 66.9468Z",
    fill: "#6580E1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.748 110.402L110.565 121.265L96.6526 129.298L77.8361 118.434L91.748 110.402Z",
    fill: "#061C43"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M110.565 34.356L110.565 56.0835L91.748 45.2197L91.748 110.402L110.565 121.266L110.565 142.993L185.83 186.447L185.83 121.265L148.197 99.5378L148.197 121.265L167.014 132.129L167.014 153.856L110.565 121.266L110.565 56.0835L167.014 88.6744L167.014 66.9469L110.565 34.356Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6344_33285",
    x: 58.0078,
    y: 5.25891,
    width: 149.352,
    height: 218.457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: -49
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6344_33285"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6344_33285",
    x1: 110.732,
    y1: 198.059,
    x2: 184.667,
    y2: 101.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#BBC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6580E1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGok1);
export default __webpack_public_path__ + "static/media/gok-1.2b0652d45223b82666118b0f4be4e55c.svg";
export { ForwardRef as ReactComponent };